export enum RequestedUserStatus {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED',
  EXPIRED = 'EXPIRED',
  RECLAIMED = 'RECLAIMED'
}

export enum RequestedUserType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}
export default interface ProfileRequestAccessVO {
  id: string;
  companyId: string;
  profileId: string;
  mailId: string;
  status: RequestedUserStatus;
  requestedTs: Date;
  approvedBy: string;
  approvedTs: Date | null;
  expiryDate: Date | null;
  rejectedBy: string;
  rejectedTs: Date | null;
  additionalParams: Record<string, unknown>;
  userType: RequestedUserType;
  userToken: string;
  ndaSigned: boolean;
  ndaOrigin: boolean;
  viewId?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  companyName?: string;
  jobTitle?: string;
  productCategory?: string[];
  policyTermsAgreed: { [key: string]: string };
  downloadRestricted: boolean;
  subscribedDetails?: { status: string; subscribedOn: Date };
  preferences?: {
    access_type?: string;
    download?: boolean;
    accessibility_details?: {
      sharedViewIds?: string[];
      crmBypassAccessDetailsMap?: Record<string, unknown>;
      sharedViewPermissionMap?: Record<string, string>;
    };
  };
  // backend sometimes returns these for validation errors (e.g. access denied, invalid OTP)
  additional_message?: string;
  message?: string;
}

export interface GuestDetailsVO {
  firstName: string;
  lastName: string;
  address: string;
  companyName?: string;
  jobTitle?: string;
  productCategory?: string[];
}

export const defaultwebFormDetails: GuestDetailsVO = {
  firstName: '',
  lastName: '',
  address: '',
  companyName: '',
  jobTitle: '',
  productCategory: []
};
